import { render, staticRenderFns } from "./Bookings.vue?vue&type=template&id=37a43ee2&scoped=true&"
import script from "./Bookings.vue?vue&type=script&lang=ts&"
export * from "./Bookings.vue?vue&type=script&lang=ts&"
import style0 from "./Bookings.vue?vue&type=style&index=0&id=37a43ee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a43ee2",
  null
  
)

export default component.exports